__webpack_require__.p = "/apps/text_templates/js/";